<div [ycHidden]="addingCategory" 
  [formGroup]="formGroup">

  <div class="mb-3 details-subheader">
    <yc-i18n
      key="common:textInKindBudgetNewItemDesc"
      defaultValue="Add a new item to be used for your in-kind budgets and awards.">
    </yc-i18n>
  </div>

  <!-- Item Name -->
  <div class="mb-2">
    <yc-input
      name="itemName"
      [label]="'common:textItemName' | ycI18n: 'Item name'">
    </yc-input>
  </div>

  <!-- Category -->
  <div class="d-flex mb-2 align-items-center">
    <div class="flex-grow-1 me-2">
      <yc-typeahead-select
        name="categoryId"
        [items]="categoryOptions"
        [label]="'GLOBAL:textCategory' | ycI18n: 'Category'">
      </yc-typeahead-select>
    </div>
    <!-- Add Category-->
    <div class="mt-3">
      <yc-button
        [link]="true"
        [fontAwesomeIcon]="'plus'"
        [langKey]="'NAV:textNew'"
        [defaultText]="'New'"
        (onClick)="onNewCategory()">
      </yc-button>
    </div>
  </div>

  <div class="d-flex mb-2">
    <!-- Total Available Units -->
    <div class="flex-basis-33 me-2">
      <yc-input
        [isNumber]="true"
        [numberOfDecimals]="0"
        name="units"
        [label]="'common:textTotalAvailableUnits' | ycI18n: 'Total available units'">      
      </yc-input>
    </div>

    <!-- Value Per Unit -->
    <div class="flex-basis-33 me-2">
      <yc-input
        [currencyData]="currencyData"
        [isNumber]="true"
        [rightIcons]="rightIcons"
        name="value"
        [label]="'common:textValuePerUnit' | ycI18n: 'Value per unit'">      
      </yc-input>
    </div>

    <!-- Allocated Units -->
    <div class="flex-basis-33">
      <yc-input
        [isNumber]="true"
        [numberOfDecimals]="0"
        name="allocatedUnits"
        [label]="'common:textAllocatedUnits' | ycI18n: 'Allocated units'"
        [showQuestionMarkForTooltip]="true"
        [tooltipText]="'BUDGET:textAllocatedUnitsTooltip' | ycI18n: 'Specify the number of items or units to include in the budget total calculation.'">      
      </yc-input>
    </div>
  </div>

  <!-- Identification -->
  <div>
    <yc-input
      name="identification"
      [label]="'common:textUniqueIdNumber' | ycI18n: 'Unique identification number'"
      [showQuestionMarkForTooltip]="true"
      [popoverTemplate]="uniqueIdPopover">
    </yc-input>
  </div>

</div>

<!-- Create Category View -->
<div [ycHidden]="!addingCategory" 
  [formGroup]="categoryGroup">
  <div class="mb-2">
    <yc-input
      name="name"
      [label]="'common:lblName' | ycI18n">
    </yc-input>
  </div>

  <div class="mb-2">
    <yc-typeahead-select
      name="type"
      [items]="typeOptions"
      [showQuestionMarkForTooltip]="true"
      [popoverTemplate]="inKindTypePopover"
      [label]="'common:hdrType' | ycI18n">
    </yc-typeahead-select>
  </div>
  
  <div *ngIf="hasInternational"
    class="mb-2">
    <yc-language-form-control
      name="defaultLang"
      [showClear]="false"
      [label]="'CONFIG:textDefaultItemLanguage' | ycI18n: 'Default item language'"
      [langKeys]="langKeys">
    </yc-language-form-control>
  </div>
</div>

<ng-template #uniqueIdPopover>
  <yc-i18n
    key="common:textBudgetIdHelp2"
    defaultValue="This can be any unique ID used for invoicing and reporting. It cannot be changed after creating the item.">
  </yc-i18n> 
  <a [href]="uniqueIdHelpLink" 
    target="_blank"
    (click)="trackClick(uniqueIdHelpLink)"
    class="ms-2">
    <yc-i18n
      key="common:textLearnMore"
      defaultValue="Learn more">
    </yc-i18n>
  </a>
</ng-template>

<ng-template #inKindTypePopover>
  <yc-i18n
    key="BUDGET:textInKindTypeHelp"
    defaultValue="This is an additional level of classification for your in-kind offerings.">
  </yc-i18n> 
  <a [href]="inKindTypeHelpLink" 
    target="_blank"
    (click)="trackClick(inKindTypeHelpLink)"
    class="ms-2">
    <yc-i18n
      key="common:textLearnMore"
      defaultValue="Learn more">
    </yc-i18n>
  </a>
</ng-template>